<template>
    <div class="input select">
        <label v-if="label">{{ label }}</label>
        <select ref="select" :multiple="multiple">
            <option v-if="placeholder"></option>
            <slot></slot>
        </select>
    </div>
</template>

<script>
import $ from 'jquery'
import 'select2'

export default {
    props: {
        modelValue: {
            type: [String, Number, Object],
            default: null
        },
        groups: {
            type: [Array, Object, Function],
            default: null
        },
        choices: {
            type: [Array, Object, Function],
            default: () => []
        },
        options: {
            type: Object,
            default: () => { }
        },
        placeholder: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        multiple: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            instance: null
        }
    },
    watch: {
        groups (value) {
            this.build()
        },
        choices (value) {
            this.build()
        },
        modelValue (newValue) {
            // Update select2 when the v-model value changes externally
            if (this.instance) {
                $(this.$refs.select).val(this.modelValue).trigger('change')
            }
        },
        disabled (newValue) {
            // Update select2 disabled state
            if (this.instance) {
                $(this.$refs.select).prop('disabled', newValue)
            }
        }
    },
    methods: {
        build () {
            const data = this.groups || this.choices
            this.instance = $(this.$refs.select).select2({
                data,
                theme: 'bootstrap4',
                placeholder: this.placeholder,
                allowClear: false,
                width: '100%',
                disabled: this.disabled,
                ...this.options
            })

            this.instance.on('select2:select', this.onSelect)
            this.instance.on('select2:unselect', this.onUnselect)

            $(this.$refs.select).val(this.modelValue).trigger('change')
        },
        clearSelection () {
            $(this.$refs.select).val(null).trigger('change')
        },
        onSelect (e) {
           this.$emit('update:modelValue', this.multiple ? $(this.$refs.select).val() : e.params.data.value)
        },
        onUnselect (e) {
            this.$emit('update:modelValue', this.multiple ? $(this.$refs.select).val() : null)
        }
    },
    mounted () {
        this.build()
    },
    destroyed () {
        this.instance.select2('destroy')
    }
}

// Add focus to select on Screen Type dropdown
$(document).on('select2:open', () => {
    document.querySelector('.select2-search__field').focus();
});
</script>
